import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { from, Observable, switchMap } from 'rxjs'

interface ConfirmData {
  message: string
  html?: boolean
  icon?: string
  iconColor?: 'primary' | 'warn' | 'accent'
  yesBtnLabel?: string
  noBtnLabel?: string
  hideNoButton?: boolean
  width?: string
  translationTokens?: Record<string, string>
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  constructor(private dialog: MatDialog) { }

  public confirm(data: string | ConfirmData = 'common.are-you-sure'): Observable<boolean> {
    if (typeof data === 'string') {
      data = { message: data }
    }

    data.yesBtnLabel = data.yesBtnLabel || 'common.yes'
    data.noBtnLabel = data.noBtnLabel || 'common.no'
    data.html = Boolean(data.html)
    data.hideNoButton = Boolean(data.hideNoButton)

    // Dynamic import to avoid circular dependency between @mmx/shared and @mmx/components at module load time.
    // At runtime the module is already cached so the promise resolves instantly.
    return from(import('@mmx/components')).pipe(
      switchMap(({ ConfirmComponent }) => {
        const dialogRef = this.dialog.open(ConfirmComponent, {
          width: data.width || '380px',
          disableClose: true,
          data,
          panelClass: 'dialog-form',
        })
        return dialogRef.afterClosed()
      }),
    )
  }
}
